import { useId } from 'react';

const useRandomId = (prefix = 'random-id-') => {
  const id = useId();

  return `${prefix}-${id}`;
};

export default useRandomId;
